// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__17GnM","tooltiptext":"styles_tooltiptext__3BDQA"};